import React from 'react';
import { Route } from 'react-router-dom';
import { STAFF_PATHS } from '../utils/staffPaths';
import Login from './Login';
import InternalStaffRoute from './InternalStaffRoute';
import AdminDashboard from './AdminDashboard';
import MarketingPage from './MarketingPage';
import StaffTeamPage from './StaffTeamPage';
import StaffSettingsPage from './StaffSettingsPage';

// Used directly inside App's Routes: old /admin URLs have no alias or redirect.
export function staffPortalRoutes() {
  return [
    <Route key="staff-entry" path={STAFF_PATHS.root} element={<Login />} />,
    <Route key="staff-login" path={STAFF_PATHS.login} element={<Login />} />,
    <Route key="staff-dashboard" path={STAFF_PATHS.dashboard} element={<InternalStaffRoute adminOnly><AdminDashboard /></InternalStaffRoute>} />,
    <Route key="staff-section" path={`${STAFF_PATHS.dashboard}/:section`} element={<InternalStaffRoute adminOnly><AdminDashboard /></InternalStaffRoute>} />,
    <Route key="staff-marketing" path={STAFF_PATHS.marketing} element={<InternalStaffRoute><MarketingPage /></InternalStaffRoute>} />,
    <Route key="staff-team" path={STAFF_PATHS.team} element={<InternalStaffRoute adminOnly><StaffTeamPage /></InternalStaffRoute>} />,
    <Route key="staff-settings" path={STAFF_PATHS.settings} element={<InternalStaffRoute><StaffSettingsPage /></InternalStaffRoute>} />,
  ];
}
